export const DASHBOARD_ACTION = {
  ADD_QUESTION: "ADD_QUESTION",
  ADD_HEADING_OR_TEXT: "ADD_HEADING_OR_TEXT",
  ADD_LINK_CARD: "ADD_LINK_CARD",
  ADD_SECTION: "ADD_SECTION",
  ADD_FILTER_PARAMETER: "ADD_FILTER_PARAMETER",
  ADD_ACTION_ELEMENT: "ADD_ACTION_ELEMENT",
  EXTRA_EDIT_BUTTONS_MENU: "EXTRA_EDIT_BUTTONS_MENU",
  COPY_ANALYTICS_DASHBOARD: "COPY_ANALYTICS_DASHBOARD",
  EDIT_DASHBOARD: "EDIT_DASHBOARD",
  DASHBOARD_SHARING: "DASHBOARD_SHARING",
  REFRESH_WIDGET: "REFRESH_WIDGET",
  FULLSCREEN_TOGGLE: "FULLSCREEN_TOGGLE",
  DASHBOARD_HEADER_ACTION_DIVIDER: "DASHBOARD_HEADER_ACTION_DIVIDER",
  DASHBOARD_BOOKMARK: "DASHBOARD_BOOKMARK",
  DASHBOARD_INFO: "DASHBOARD_INFO",
  DASHBOARD_ACTION_MENU: "DASHBOARD_ACTION_MENU",
  FULLSCREEN_ANALYTICS_DASHBOARD: "FULLSCREEN_ANALYTICS_DASHBOARD",
  DOWNLOAD_PDF: "DOWNLOAD_PDF",
  // Modular embeddings (modular embedding, modular embedding SDK)
  DASHBOARD_SUBSCRIPTIONS: "DASHBOARD_SUBSCRIPTIONS",
  REFRESH_INDICATOR: "REFRESH_INDICATOR",
  SAVE_CURRENT_VIEW: "SAVE_CURRENT_VIEW",
} as const;

type DashboardActionKey = keyof typeof DASHBOARD_ACTION;
export type DashboardActionValue =
  (typeof DASHBOARD_ACTION)[DashboardActionKey];
